'use client'

import { env } from '@shared/config/env'
import { FEATURE_FLAG_KEYS } from '@shared/constants'
import { useMemo } from 'react'

import { useFlag } from '@podo/flags/react'

export const useTestableFlag = (key: string, userId?: number) => {
  const flag = useFlag(key)
  const testableUserIdList = useFlag(FEATURE_FLAG_KEYS.TESTABLE_USER_ID_LIST)

  const parsedUserIds = useMemo(() => {
    try {
      return JSON.parse(testableUserIdList.value as string) as string[]
    } catch {
      return []
    }
  }, [testableUserIdList.value])

  const isTestableEnabled = useMemo(() => {
    if (env.NEXT_PUBLIC_APP_ENV !== 'production') {
      return flag.enabled
    }
    return userId !== undefined && userId !== null && parsedUserIds.includes(userId.toString()) && flag.enabled
  }, [flag.enabled, userId, parsedUserIds])

  return {
    enabled: flag.enabled,
    value: flag.value,
    isTestableEnabled,
  }
}
